export default "__VITE_PUBLIC_ASSET__a571e36b__"